import React, { Fragment } from "react";
import { Form } from "react-bootstrap";
import PropTypes from 'prop-types';
import { TextInput } from "../../../Helpers/Inputs";
import { InputMaskDate, NumberFormatDollars } from "../../../Helpers/Formatters";
import { KENTUCKY, FLORIDA, SOUTH_CAROLINA } from '../../../Helpers/Constants/States';

export default function InsurancePolicyForm(props) {

    const state = props.state;

    const onFieldChange = (field, value) => {
        // call onChange with the whole updated form
        props.onChange({ ...props.formState, [field]: value });
    }

    // manually call setValue for fields that don't play nice with react-hook-form register
    const handleValueChange = (field, value, longFieldName) => {
        props.setValue(longFieldName, value);
        onFieldChange(field, value);
        props.trigger(longFieldName);
    }

    return (
        <div>
            {((state === FLORIDA && props.replaceExistingCoverage === "Yes") || (state === KENTUCKY || state === SOUTH_CAROLINA)) &&
                <Fragment>
                    <p className="section-title">Insurance Policy {props.index + 1}</p>
                    <Form.Group>
                        <TextInput
                            name={`insurancePolicies[${props.index}].company`}
                            id={`insurancePolicies[${props.index}].company`}
                            label="Company Name"
                            value={props.formState.company}
                            errors={props.errors && props.errors.company}
                            inputRef={props.register}
                            onChange={(e) => handleValueChange('company', e.target.value, `insurancePolicies[${props.index}].company`)}
                        />
                    </Form.Group>
                </Fragment>
            }

            {((state === FLORIDA && props.replaceExistingCoverage === "Yes") || (state === KENTUCKY || state === SOUTH_CAROLINA)) &&
                <Form.Group>
                    <TextInput
                        name={`insurancePolicies[${props.index}].policyNumber`}
                        id={`insurancePolicies[${props.index}].policyNumber`}
                        label="Policy Number"
                        value={props.formState.policyNumber}
                        errors={props.errors && props.errors.policyNumber}
                        inputRef={props.register}
                        onChange={(e) => handleValueChange('policyNumber', e.target.value, `insurancePolicies[${props.index}].policyNumber`)}
                    />
                </Form.Group>
            }

            {(state === KENTUCKY) &&
                <Form.Group>
                    <TextInput
                        name={`insurancePolicies[${props.index}].faceAmount`}
                        id={`insurancePolicies[${props.index}].faceAmount`}
                        label="Benefit Amount"
                        value={props.formState.faceAmount}
                        errors={props.errors && props.errors.faceAmount}
                        inputRef={props.register}
                        onChange={(e) => handleValueChange('faceAmount', e.target.value, `insurancePolicies[${props.index}].faceAmount`)}
                        InputProps={{
                            inputComponent: NumberFormatDollars,
                        }}
                    />
                </Form.Group>
            }

            {(state === FLORIDA && props.replaceExistingCoverage === "Yes") &&
                <Form.Group>
                    <TextInput
                        name={`insurancePolicies[${props.index}].insuranceDate`}
                        id={`insurancePolicies[${props.index}].insuranceDate`}
                        label="Issue Date"
                        value={props.formState.insuranceDate}
                        errors={props.errors && props.errors.insuranceDate}
                        inputRef={props.register}
                        onChange={(e) => handleValueChange('insuranceDate', e.target.value, `insurancePolicies[${props.index}].insuranceDate`)}
                        InputProps={{
                            inputComponent: InputMaskDate,
                        }}
                    />
                </Form.Group>
            }

            {state === SOUTH_CAROLINA &&
                <Form.Group>
                    <TextInput
                        name={`insurancePolicies[${props.index}].replaceExistingCoverageType`}
                        id={`insurancePolicies[${props.index}].replaceExistingCoverageType`}
                        label="Policy Type"
                        value={props.formState.replaceExistingCoverageType}
                        errors={props.errors && props.errors.replaceExistingCoverageType}
                        inputRef={props.register}
                        onChange={(e) => handleValueChange('replaceExistingCoverageType', e.target.value, `insurancePolicies[${props.index}].replaceExistingCoverageType`)}
                    />
                </Form.Group>
            }
        </div>
    )
}

InsurancePolicyForm.propTypes = {
    formState: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    register: PropTypes.func.isRequired,
    errors: PropTypes.any,
}


// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/steps/InsurancePolicyForm.js